import './order.scss';
import './parts/select.scss';
import OrderForm from "./parts/OrderForm";
import customSelect from './parts/select';

let callButtons = document.querySelectorAll('.js-make-order');
let awayButtons = document.querySelectorAll('.js-make-order');
let closeButtons = document.querySelectorAll('.js-order-form-close');

let form = document.querySelector('.product__order');

if (form) {

    awayButtons.forEach( button => {
        button.addEventListener('click', event => {
            if ( event.target.href == '' ||  event.target.href == '#' ) {
                event.preventDefault();
            }
        })
    })

    callButtons.forEach( button => {
        button.addEventListener('click', event => {
            event.preventDefault();
            form.style.display = '';
            form.style.scrollMarginTop = '20px';
            setTimeout(() => {form.scrollIntoView(true)}, 30);

        })
    })

    closeButtons.forEach( button => {
        button.addEventListener('click', event => {
            form.style.display = 'none';
        })
    })

    let orderImagesHolder = document.querySelector('.js-order-images');
    let paymentTypeHolder = document.querySelector('.js-payment-type');

    form.querySelectorAll( '.js-order-param' ).forEach( (orderBlock, index) => {
        let isColors = orderBlock.classList.contains('js-order-colors');
        let attributeInputs = orderBlock.querySelectorAll( 'input' );
        let currentParamTitle = orderBlock.querySelector('.js-order-current-attr');
        attributeInputs.forEach( input => {
            input.addEventListener('change', event => {
                let labelName = event.target.dataset.label;
                let value = event.target.value;
                let labels = orderBlock.querySelectorAll( '.js-order-label');
                if ( labels ) {
                    labels.forEach((label, ind) => {
                        let labelFor = label.dataset.for;
                        if (labelFor !== labelName) {
                            label.classList.remove('--active');
                            if ( isColors ) {
                                orderImagesHolder.querySelectorAll('.js-order-image').forEach(image => {
                                    if (image.dataset.for == labelName) {
                                        image.classList.add('--active');
                                    } else {
                                        image.classList.remove('--active');
                                    }
                                })
                            }
                        } else {
                            label.classList.add('--active');
                        }
                    });
                }

                if ( currentParamTitle ) {
                    currentParamTitle.innerText = value;
                }

                if ( event.target.name == 'payment' ) {
                    let submit = form.querySelector('.js-order-form-submit');
                    let text = submit.dataset.online;
                    if ( value == 'delivery' ) {
                        text = submit.dataset.delivery;
                        paymentTypeHolder.style.display = '';
                    } else {
                        paymentTypeHolder.style.display = 'none';
                    }

                    form.querySelector('.js-order-form-submit > span').innerText = text;
                }

            })
        })
    })

    let qtiInput = form.querySelector('.js-order-qti-input');
    let qtiMinus = form.querySelector('.js-order-qti-minus');
    let qtiPlus = form.querySelector('.js-order-qti-plus');
    let price = parseInt( form.querySelector('.js-order-price').value );
    let total = form.querySelector('.js-order-total');
    let qtiText = form.querySelector('.js-order-current-qti');
    let totalInput = form.querySelector('input[name="total"]');
    if ( qtiInput ) {
        qtiInput.addEventListener('change', () => {
            let currentValue = parseInt( qtiInput.value );
            if ( isNaN( currentValue ) || currentValue < 1  ) {
                currentValue = 1;
            }
            if ( currentValue <= 2 ) {
                qtiMinus.classList.add('disabled');
            } else {
                qtiMinus.classList.remove('disabled');
            }
            let newValue = currentValue;
            qtiInput.value = newValue;
            qtiText.innerText = newValue;

            let totalNumber = newValue * price;
            total.innerText = totalNumber.toLocaleString();
            totalInput.value = newValue
        })
        if ( qtiMinus ) {
            qtiMinus.addEventListener('click', () => {
                let currentValue = parseInt( qtiInput.value );
                if ( isNaN( currentValue ) ) {
                    currentValue = 1;
                }
                if ( currentValue <= 2 ) {
                    qtiMinus.classList.add('disabled');
                } else {
                    qtiMinus.classList.remove('disabled');
                }
                if ( currentValue > 1 ) {
                    let newValue = currentValue - 1;
                    qtiInput.value = newValue;
                    qtiText.innerText = newValue;

                    let totalNumber = newValue * price;
                    total.innerText = totalNumber.toLocaleString();
                    totalInput.value = newValue
                }
            })
        }
        if ( qtiPlus ) {
            qtiPlus.addEventListener('click', () => {
                let currentValue = parseInt( qtiInput.value );
                if ( isNaN( currentValue ) ) {
                    currentValue = 1;
                }
                let newValue = currentValue + 1;
                qtiInput.value = newValue;
                qtiText.innerText = newValue;

                qtiMinus.classList.remove('disabled');
                let totalNumber = newValue * price;
                total.innerText = totalNumber.toLocaleString();
            })
        }
    }

    let continueButton = form.querySelector('.js-order-continue');
    let step1 = form.querySelector('.js-order-step-1');
    let step2 = form.querySelector('.js-order-step-2');
    let step3 = form.querySelector('.js-order-step-3');
    let step4 = form.querySelector('.js-order-step-4');
    let step4Total = step4.querySelector('.js-order-info-total');
    let step4Number = step4.querySelector('.js-order-info-number');
    let resume = form.querySelector('.js-order-resume');
    let resumeContent = form.querySelector('.js-order-resume-content');
    let backToStep1 = form.querySelector('.js-order-back');
    let hideAfterSuccess = form.querySelectorAll('.js-hide-when-success');
    continueButton.addEventListener('click', () => {
        step1.style.display = 'none';
        step2.style.display = '';
        step2.style.scrollMarginTop = '20px';
        setTimeout(() => {step2.scrollIntoView(true);}, 30);
        step3.style.display = 'none';
        resume.style.display = '';
        resumeContent.innerHTML = '';
        form.querySelectorAll('.js-order-param-title').forEach( title => {
            let newElement = title.cloneNode(true);
            resumeContent.appendChild(newElement);
        })
    });

    backToStep1.addEventListener('click', () => {
        step1.style.display = '';
        step2.style.display = 'none';
        step3.style.display = 'none';
        resume.style.display = 'none';
        resumeContent.innerHTML = '';
    });

    let $select = jQuery('.js-order-form__select');

    if ($select.length) {
        customSelect($select);
    }

    const step3Action = () => {
        hideAfterSuccess.forEach( el => {
            el.style.display = 'none';
        })
        step3.style.display = '';
        step3.style.scrollMarginTop = '20px';
        setTimeout(() => {step3.scrollIntoView(true);}, 30);
    }

    const step4Action = ( total, number ) => {
        hideAfterSuccess.forEach( el => {
            el.style.display = 'none';
        })
        step3.style.display = 'none';
        step4.style.display = '';
        step4.style.scrollMarginTop = '20px';

        if ( ! isNaN( total ) ) {
            step4Total.innerHTML = total + '&nbsp;&#8381;';
        }
        if ( number && number != 'undefined' ) {
            step4Number.innerText = ' заказа № ' + ( number.toString() );
        }

        setTimeout(() => {step4.scrollIntoView(true);}, 30);
    }

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const orderId = urlParams.get('order');
    const result = urlParams.get('result');

    if ( orderId && result == 'success' ) {
        step3Action();
        form.style.display = '';
        form.style.scrollMarginTop = '20px';
        setTimeout(() => {form.scrollIntoView(true)}, 30);
    } else {
        let settings = {
            sendRestUrl: kvadraOrderData.sendRestUrl,
            resultAction: step3Action,
            invoiceAction: step4Action,
            source: kvadraOrderData.source,
        }
        new OrderForm(form, settings);
    }
}
